import { launchSmartApp } from '@getvim/vim-connect/src/infra/common/api/patient/priorAuth';

export const launchSmartAppQuery = async (context: any) => {
  const launchURL = await launchSmartApp({
    ...context,
  });

  return launchURL;
};
